export const BASE = 'ordoro/ui/dashboard'
export const SET_SHOW_SETUP_GUIDE = `${BASE}/SET_SHOW_SETUP_GUIDE`

export function setShowSetupGuide(visible) {
  return {
    type: SET_SHOW_SETUP_GUIDE,
    payload: visible,
  }
}
